import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '../components/ProtectedRoute';
import LoginPage from '../pages/LoginPage';
import { UsersPage } from '../pages/UsersPage';
import { LoggingPage } from '../pages/LoggingPage';
import { EntriesPage } from '../pages/EntriesPage';
import { WeeklySummaryPage } from '../pages/WeeklySummaryPage';
import { MedicalHistoryPage } from '../pages/MedicalHistoryPage';
import { ExpensePage } from '../pages/ExpensePage';
import { PublicDailySummaryPage } from '../pages/PublicDailySummaryPage';

/**
 * Application Routes
 *
 * Defines all routes in the application.
 * Protected routes are wrapped with ProtectedRoute component
 * which enforces authentication and optional role-based access control.
 */
export function AppRoutes() {
	return (
		<Routes>
			{/* Public routes */}
			<Route path="/login" element={<LoginPage />} />
			<Route path="/daily-summary" element={<PublicDailySummaryPage />} />

			{/* Redirect root to entries (Harian is the main page) */}
			<Route
				path="/"
				element={
					<ProtectedRoute>
						<Navigate to="/entries" replace />
					</ProtectedRoute>
				}
			/>

			<Route
				path="/users"
				element={
					<ProtectedRoute requiredRoles={['admin', 'superadmin']}>
						<UsersPage />
					</ProtectedRoute>
				}
			/>

			<Route
				path="/log"
				element={
					<ProtectedRoute requiredRoles={['editor', 'admin', 'superadmin']}>
						<LoggingPage />
					</ProtectedRoute>
				}
			/>

			<Route
				path="/entries"
				element={
					<ProtectedRoute>
						<EntriesPage />
					</ProtectedRoute>
				}
			/>

			<Route
				path="/weekly"
				element={
					<ProtectedRoute>
						<WeeklySummaryPage />
					</ProtectedRoute>
				}
			/>

			<Route
				path="/medical-history"
				element={
					<ProtectedRoute>
						<MedicalHistoryPage />
					</ProtectedRoute>
				}
			/>

			<Route
				path="/expenses"
				element={
					<ProtectedRoute requiredRoles={['admin', 'superadmin']}>
						<ExpensePage />
					</ProtectedRoute>
				}
			/>

			{/* Catch-all - redirect to entries */}
			<Route path="*" element={<Navigate to="/entries" replace />} />
		</Routes>
	);
}
